import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { SelectNewProjectTypePopup } from './SelectNewProjectTypePopup';

const POPUP_KEY = Symbol('SELECT_NEW_PROJECT_TYPE');

/**
 * Open the "select new project type" popup
 * @returns {function({title: string, description: string, displayBackButton: boolean}|null): Promise<object|null>}
 */
export const useSelectNewProjectTypePopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(POPUP_KEY, SelectNewProjectTypePopup);
  });

  return useCallback(
    ({ title, description, displayBackButton, narrow } = {}) => {
      return new Promise((resolve) => {
        popups.openPopup(POPUP_KEY, {
          title,
          description,
          displayBackButton,
          narrow,

          onSubmit: (result) => {
            popups.closePopup(POPUP_KEY);
            resolve(result);
          },
          onClose: () => {
            popups.closePopup(POPUP_KEY);
            resolve(null);
          },
        });
      });
    },
    [popups]
  );
};
